import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const EditProjectDialog = ({ open, onOpenChange, editingProject, setEditingProject, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg border border-zinc-200  rounded-none p-0 max-h-[90vh] overflow-y-auto">
      <DialogHeader className="p-6 pb-0">
        <DialogTitle className="text-2xl font-heading font-bold uppercase tracking-wide">Edit Project</DialogTitle>
      </DialogHeader>

      {editingProject && (
        <form onSubmit={onSubmit} className="p-6 pt-4 space-y-4">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">Project Name</label>
            <input
              type="text"
              value={editingProject.name}
              onChange={(e) => setEditingProject({ ...editingProject, name: e.target.value })}
              required
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">Client Name</label>
            <input
              type="text"
              value={editingProject.client_name}
              onChange={(e) => setEditingProject({ ...editingProject, client_name: e.target.value })}
              required
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">Address</label>
            <input
              type="text"
              value={editingProject.address || ''}
              onChange={(e) => setEditingProject({ ...editingProject, address: e.target.value })}
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="123 Main St, City, ST 12345"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">Project Type</label>
              <select
                value={editingProject.project_type}
                onChange={(e) => setEditingProject({ ...editingProject, project_type: e.target.value })}
                className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
              >
                <option value="Electrical">Electrical</option>
                <option value="Plumbing">Plumbing</option>
                <option value="HVAC">HVAC</option>
                <option value="Mechanical">Mechanical</option>
                <option value="Multi-Trade">Multi-Trade</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">Status</label>
              <select
                value={editingProject.status}
                onChange={(e) => setEditingProject({ ...editingProject, status: e.target.value })}
                className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
              >
                <option value="Active">Active</option>
                <option value="On Hold">On Hold</option>
                <option value="Complete">Complete</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">Start Date</label>
              <input
                type="date"
                value={editingProject.start_date || ''}
                onChange={(e) => setEditingProject({ ...editingProject, start_date: e.target.value })}
                className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide mb-2">End Date</label>
              <input
                type="date"
                value={editingProject.end_date || ''}
                onChange={(e) => setEditingProject({ ...editingProject, end_date: e.target.value })}
                className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide mb-2">Budget</label>
            <input
              type="number"
              value={editingProject.total_budget}
              onChange={(e) => setEditingProject({ ...editingProject, total_budget: e.target.value })}
              className="w-full h-11 border border-zinc-200 bg-white text-zinc-900 text-sm px-3"
            />
          </div>
          <div className="flex gap-3 pt-4">
            <button type="button" onClick={() => onOpenChange(false)} className="flex-1 h-10 bg-white text-zinc-900 font-bold uppercase border border-zinc-200 hover:bg-zinc-50">Cancel</button>
            <button type="submit" className="flex-1 h-10 bg-primary text-zinc-900 font-bold uppercase border border-zinc-200  hover:bg-primary-hover active:translate-y-1">Save</button>
          </div>
        </form>
      )}
    </DialogContent>
  </Dialog>
);
